export default __webpack_public_path__ + "static/media/through-the-gates-of-yog-sothoth.e64a483f.jpg";